export default __webpack_public_path__ + "static/media/pub.69930ae0.svg";